import { Box, Button, List, Tag } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { Owner } from '../DataTable/_Owner'
import { ExpensableOwner } from '../DataTable/types'

export interface WarningModalProps {
  onClose: () => void
  onSkipAndContinue: () => void
  onCancel: () => void
  totalFailedEmployees: number
  allExpensesAreInvalid: boolean
  hashIdEmployees: Record<number, ExpensableOwner>
  hashEmployeeIdAndExpensesCount: Record<number, number>
}

export const WarningModal = ({
  onClose,
  onCancel,
  onSkipAndContinue,
  allExpensesAreInvalid,
  totalFailedEmployees,
  hashIdEmployees,
  hashEmployeeIdAndExpensesCount,
}: WarningModalProps) => {
  const title = i18n.tp('expenses_v2.list.actions.modal.add_to_payment.warning.title', {
    count: totalFailedEmployees,
  })

  const description = allExpensesAreInvalid
    ? i18n.tp('expenses_v2.list.actions.modal.add_to_payment.warning.description_all_wrong', {
        count: totalFailedEmployees,
      })
    : i18n.tp('expenses_v2.list.actions.modal.add_to_payment.warning.description', {
        count: totalFailedEmployees,
      })

  const footer = allExpensesAreInvalid ? (
    <Button type="secondary" onClick={onCancel}>
      {i18n.t('expenses_v2.list.actions.modal.add_to_payment.buttons.cancel')}
    </Button>
  ) : (
    <>
      <Button type="secondary" onClick={onCancel}>
        {i18n.t('expenses_v2.list.actions.modal.add_to_payment.buttons.cancel')}
      </Button>
      <Button onClick={onSkipAndContinue}>
        {i18n.t('expenses_v2.list.actions.modal.add_to_payment.buttons.skip_and_continue')}
      </Button>
    </>
  )

  return (
    <Modal
      illustration="alert"
      title={title}
      description={description}
      footer={footer}
      onClose={onClose}
    >
      <Box>
        <List>
          {Object.entries(hashEmployeeIdAndExpensesCount).map(([employeeId, expensesCount]) => (
            <List.Item key={employeeId}>
              <Box
                width="full"
                flexDirection="row"
                justifyContent="spaceBetween"
                alignItems="center"
              >
                <Owner owner={hashIdEmployees[+employeeId]} />
                <Box flexDirection="row" gap="s12">
                  <Tag leftItem="icon" icon="alert-circle" type="radical">
                    {i18n.tp('expenses_v2.list.actions.modal.add_to_payment.warning.num_expenses', {
                      count: expensesCount,
                    })}
                  </Tag>
                </Box>
              </Box>
            </List.Item>
          ))}
        </List>
      </Box>
    </Modal>
  )
}
